import React from 'react';
import PropTypes from 'prop-types';
import { Button as SaaghiButton } from '@takhfifan/saaghi';

const Button = (props) => {
	return <SaaghiButton {...props} />;
};

Button.propTypes = {
	label: PropTypes.string,
	onClick: PropTypes.func,
	className: PropTypes.string,
	variant: PropTypes.string,
	size: PropTypes.string,
	isLoading: PropTypes.bool,
	disabled: PropTypes.bool,
	color: PropTypes.string,
	startIcon: PropTypes.string,
	endIcon: PropTypes.string,
	block: PropTypes.bool,
};

export default Button;
